import { clsx } from "clsx";

import { twMerge } from "tailwind-merge";
import { validRALRanges } from "./constant";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const isValidRAL = (val) => {
    const num = parseInt(val, 10);
    return validRALRanges.some((range) => num >= range.min && num <= range.max);
};
